<template>
    <div>
        <header>
            <div class="container-fluid">
                <div id="top" class="row">
                    <div class="col text-center">
                        <router-link to='/' class="logo">
                            <img src="/images/logo.png" alt="De Duursportcoach">
                        </router-link>
                    </div>
                </div>
            </div>
        </header>

        <main role="main" class="pt-5">
            <section id="error">
                <div class="container-wrapper-white">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col pt-5 pb-5">
                                <h1 class="text-blue">Pagina niet gevonden</h1>
                                <p class="text-blue">
                                    Klik hier om naar de
                                    <router-link to='/' class="text-blue">homepage</router-link>
                                    te gaan.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
export default {}
</script>
